import Collapse from 'ui/bend/animations/Collapse'

export default Collapse